<template src="./login.html"></template>
<script>
import { ToolIcon } from "vue-feather-icons";
export default {
  components: {
    ToolIcon,
  },
  data() {
    return {
      idWebClinic: null,
      email: "",
      password: "",
      checkbox_remember_me: true,
      bearer_code: "1",
      options: {},
      senhaInvalida: false,
      esqueceuSenha: false,
      passwordType: "password",
      iconPasswordConfirmation: "EyeOffIcon"
    };
  },
  mounted: function() {
    var vm = this;
    vm.$vs.loading.close();
    if (vm.$cookies.get("user") !== null) {
      console.log(vm.$cookies);
      vm.email = vm.$cookies.get("user").userName;
      vm.password = this.$cookies.get("user").password;
    }
  },
  methods: {
    renova() {
      var vm = this;
      this.axios
        .post(`${this.$store.state.filooServer}users/forgot-password`, {
          email: this.email,
          type: "AAS"
        })
        .then(function(response) {
          console.log(response);
          vm.esqueceuSenha = false;
          vm.$swal(
            "Esqueci minha senha",
            "Um e-mail foi enviado para a configuração da sua nova senha.",
            "success"
          );
        })
        .catch(function() {
          vm.esqueceuSenha = false;
          vm.$swal(
            "Esqueci minha senha",
            "Ocorreu um erro ao enviar seu e-mail de renovação. Verifique se o mesmo foi digitado corretamente.",
            "warning"
          );
        });
    },

    loga() {
      var vm = this;
      console.log("Vai logar");
      this.axios
        .post(vm.$store.state.filooServer + "aas/login", {
          username: vm.email,
          password: vm.password
        })
        .then(function(response) {
          if (response.status === 200) {
            vm.$session.start();
            console.log(response);
            vm.$session.set("bearer", response.headers.authorization);
            vm.$session.set("bearerDefault", response.headers.authorization);
            vm.bearer_code = response.headers.authorization;
            var user = { userName: vm.email, password: vm.password };
            if (vm.checkbox_remember_me === true) {
              vm.$cookies.set("user", user);
            } else {
              vm.$cookies.remove("user");
            }
            console.log(vm.$session.getAll());
            vm.getMe();
          }
        })
        .catch(function(error) {
          // vm.$bvModal.show("modal-under-maintenance");
          vm.senhaInvalida = true;
          console.log({error_login: error });
        });
    },
    getMe() {
      var vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "me", {
          headers: { Authorization: vm.bearer_code }
        })
        .then(function(response) {
          vm.options = response.data;
          vm.$session.set("name", vm.options.name);
          vm.$session.set("email", vm.options.email);
          vm.$session.set("incomplete", vm.options.incomplete);
          vm.$session.set("authorities", vm.options.authorities);
          vm.$session.set("type", vm.options.type);
          vm.$session.set("userAas", vm.options.userAas);
          vm.$session.set("userAasId", vm.options.userAas.id);
          console.log(vm.options.userAas.id);
          console.log("customer", vm.options);
          vm.$router.push("/aas-dashboard");
          //vm.getProfilePhoto();
        })
        .catch(function(error) {
          console.log({error_getMe: error });
        });
    },
    getProfilePhoto() {
      var vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "webclinics/photo/download/" + vm.idWebClinic, {
          headers: { Authorization: vm.bearer_code }
        })
        .then(function(response) {
          vm.$session.set("photo", response.data);


        })
        .catch(function(error) {
          console.log(error.response.data);
        });
    },

    cadastra() {
      var vm = this;
      vm.$router.push("/pages/register");
    },

    passwordVisibility() {
      var vm = this;
      if (vm.passwordType === "password") {
        vm.passwordType = "text";
        vm.iconPasswordConfirmation = "EyeIcon";
      } else {
        vm.passwordType = "password";
        vm.iconPasswordConfirmation = "EyeOffIcon";
      }
    }
  }
};
</script>
<style src="./login.scss" lang="scss">
</style>
